import { motion } from 'framer-motion';
import styled from 'styled-components';
import React, { useEffect, useState } from 'react';
import { contrastBackground, stain1Color, stain2Color, stain3Color } from '../../../helpers/color-tokens';

const MyServicesBackgroundWrapper = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	z-index: -1;

	@media (max-width: 560px) {
		left: 0%;
	}
`;

const Background = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: ${contrastBackground};
	overflow: hidden;
`;

const Stain1 = styled(motion.div)`
	top: 20%;
	left: 2%;
	width: clamp(200px, 40vw, 2000px);
	height: clamp(200px, 40vw, 2000px);
	position: absolute;
	border-radius: 50%;
	background: ${stain1Color};
	filter: blur(50px);
	transform: translate(-50%, -50%);

	@media (min-width: 1960px) {
		top: 18%;
		left: 12%;
		width: clamp(300px, 25vw, 2000px);
		height: clamp(300px, 25vw, 2000px);
		filter: blur(50px);
	}
	@media (max-width: 1959px) {
		top: 21%;
		left: 12%;
		width: clamp(300px, 30vw, 2000px);
		height: clamp(300px, 30vw, 2000px);
		filter: blur(50px);
	}
	@media (max-width: 960px) {
		top: 18%;
		left: -3%;
		width: clamp(200px, 40vw, 2000px);
		height: clamp(200px, 40vw, 2000px);
		filter: blur(50px);
	}
	@media (max-width: 560px) {
		top: 38%;
		left: -5%;
		width: clamp(100px, 40vw, 560px);
		height: clamp(100px, 40vw, 560px);
		filter: blur(50px);
	}
	@media (max-width: 375px) {
		top: 41%;
		left: -5%;
		width: clamp(100px, 40vw, 260px);
		height: clamp(100px, 40vw, 260px);
		filter: blur(50px);
	}
`;

const Stain2 = styled(motion.div)`
	top: 19%;
	left: 25%;
	width: clamp(300px, 40vw, 2000px);
	height: clamp(300px, 40vw, 2000px);
	position: absolute;
	border-radius: 50%;
	background: ${stain2Color};
	filter: blur(50px);
	transform: translate(-50%, -50%);

	@media (min-width: 1960px) {
		top: 12%;
		left: 31%;
		width: clamp(300px, 33vw, 2000px);
		height: clamp(300px, 33vw, 2000px);
		filter: blur(50px);
	}
	@media (max-width: 1959px) {
		top: 14%;
		left: 31%;
		width: clamp(300px, 35vw, 2000px);
		height: clamp(300px, 35vw, 2000px);
		filter: blur(50px);
	}

	@media (max-width: 1379px) {
		top: 14%;
		left: 31%;
		width: clamp(300px, 40vw, 2000px);
		height: clamp(300px, 40vw, 2000px);
		filter: blur(50px);
	}

	@media (max-width: 960px) {
		top: 19%;
		left: 25%;
		width: clamp(300px, 45vw, 2000px);
		height: clamp(300px, 45vw, 2000px);
		filter: blur(50px);
	}

	@media (max-width: 560px) {
		top: 31%;
		left: 26%;
		width: clamp(100px, 50vw, 560px);
		height: clamp(100px, 56vw, 560px);
		filter: blur(50px);
	}
	@media (max-width: 375px) {
		top: 35%;
		left: 24%;
		width: clamp(100px, 50vw, 260px);
		height: clamp(100px, 53vw, 260px);
		filter: blur(50px);
	}
`;

const Stain3 = styled(motion.div)`
	top: 34%;
	left: 58%;
	width: clamp(300px, 28vw, 2000px);
	height: clamp(300px, 28vw, 2000px);
	position: absolute;
	border-radius: 50%;
	background: ${stain3Color};
	opacity: 0.4;
	filter: blur(50px);
	transform: translate(-50%, -50%);

	@media (min-width: 1960px) {
		top: 30%;
		left: 58%;
		width: clamp(300px, 23vw, 2000px);
		height: clamp(300px, 23vw, 2000px);
		filter: blur(50px);
	}
	@media (max-width: 1959px) {
		top: 34%;
		left: 58%;
		width: clamp(300px, 28vw, 2000px);
		height: clamp(300px, 28vw, 2000px);
		filter: blur(50px);
	}

	@media (max-width: 960px) {
		top: 34%;
		left: 66%;
		width: clamp(200px, 35vw, 2000px);
		height: clamp(200px, 35vw, 2000px);
		filter: blur(50px);
	}

	@media (max-width: 560px) {
		top: 39%;
		left: 64%;
		width: clamp(100px, 43vw, 560px);
		height: clamp(100px, 43vw, 560px);
		filter: blur(50px);
	}
	@media (max-width: 375px) {
		top: 43%;
		left: 65%;
		width: clamp(100px, 43vw, 260px);
		height: clamp(100px, 43vw, 260px);
		filter: blur(50px);
	}
`;

const useIs375 = () => {
	const [is375, setIs375] = useState(false);

	useEffect(() => {
		const checkScreen = () => {
			setIs375(window.matchMedia('(max-width: 375px)').matches);
		};
		checkScreen();

		window.addEventListener('resize', checkScreen);
		return () => window.removeEventListener('resize', checkScreen);
	}, []);

	return is375;
};

const useIs1800 = () => {
	const [is1800, setIs1800] = useState(false);

	useEffect(() => {
		const checkScreen = () => {
			setIs1800(window.matchMedia('(min-width: 1800px)').matches);
		};
		checkScreen();

		window.addEventListener('resize', checkScreen);
		return () => window.removeEventListener('resize', checkScreen);
	}, []);

	return is1800;
};

export const MyServicesAnimatedBackground = (): React.ReactElement => {
	const is375 = useIs375();
	const is1800 = useIs1800();

	return (
		<MyServicesBackgroundWrapper data-testid="myServices-AnimatedBackground-layout">
			<Background>
				<Stain1
					animate={
						is375
							? {
									y: ['5%', '-5%', '3%', '-3%', '5%'],
									rotate: [0, 2, -2, 1, 0],
								}
							: {
									y: ['8%', '-10%', '10%', '-10%', '10%'],
									rotate: [0, -10, 5, -5, 0, 10],
								}
					}
					transition={{
						duration: 20,
						repeat: Infinity,
						ease: 'easeInOut',
					}}
				/>
				<Stain2
					animate={
						is375
							? {
									y: ['-1%', '1%', '-6%', '0%', '-1%'],
									rotate: [0, -10, 5, -5, 0, 10],
								}
							: is1800
								? {
										y: ['-3%', '0%', '-9%', '0%', '-3%'],
										rotate: [0, -10, 5, -5, 0, 10],
									}
								: {
										y: ['-3%', '4%', '-9%', '4%', '-3%'],
										rotate: [0, -10, 5, -5, 0, 10],
									}
					}
					transition={{
						duration: 20,
						repeat: Infinity,
						ease: 'easeInOut',
					}}
				/>
				<Stain3
					animate={
						is375
							? {
									y: ['0%', '-10%', '10%', '0%'],
									rotate: [0, 5, -5, 0],
								}
							: {
									y: ['10%', '6%', '0%', '-20%', '-15%', '-6%', '10%'],
									rotate: [0, -10, 5, -5, 0, 10],
								}
					}
					transition={{
						duration: 20,
						repeat: Infinity,
						ease: 'easeInOut',
					}}
				/>
			</Background>
		</MyServicesBackgroundWrapper>
	);
};
